var _defaultValues;
import { AMOUNT } from "./field-names";
import { SubscriptionsMeta } from "../../../../util/subscription/subscriptions";
import { SubscriptionType } from "../../../../util/subscription/enums";
export var defaultValues = (_defaultValues = {}, _defaultValues[AMOUNT] = SubscriptionsMeta[SubscriptionType.SUPPORTER].prices[0], _defaultValues);
